import React from "react";

const CopyWrite = () => {
	const copywrtieStyle = {
		textAlign: "center",
		padding: "20px",
		backgroundColor: "#CDDFF7",
		color: "#180538",
		fontSize: "0.75rem",
	};
	return (
		<div style={copywrtieStyle}>
			<p>&copy; PizzaGhor & Jisan Mia</p>
		</div>
	);
};

export default CopyWrite;
